import { type NavigationGuardNext, type RouteLocationNormalized } from 'vue-router'

import { loggedIn, getUserProfile, setUserProfile } from '@/composables/auth/useAuth'
import { getLocalizationData, setLocalizationData } from '@/composables/localization/useLocalization'
import localizationArmService from '@/services/api/localization'
import { fetchProfile } from '@/services/api/user'

export const authenticationGuard = (to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext): void => {
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn.value) {
    next({ name: 'login', query: { redirect: to.fullPath } })
  } else if (to.matched.some(record => record.meta.redirectMember) && loggedIn.value) {
    next({ name: 'booking-list' })
  } else {
    next()
  }
}

export const userProfileGuard = (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext): void => {
  if (getUserProfile() === null && loggedIn.value) {
    fetchProfile(
      { requestErrorEnabled: true }
    )
      .then(({ data }) => {
        setUserProfile(data)
        next()
      })
  } else {
    next()
  }
}

export const localizationGuard = async (_to: RouteLocationNormalized, _from: RouteLocationNormalized, next: NavigationGuardNext): Promise<void> => {
  if (getLocalizationData().length === 0) {
    await localizationArmService.fetchAllLocalizations({ requestErrorEnabled: true })
      .then((data) => {
        setLocalizationData(data.data)
        next()
      })
  } else {
    next()
  }
}

export const locationReload = (): void => {
  location.reload()
}
